export default __webpack_public_path__ + "static/microhero-69e09d7fce6059df0f855cd2995b52c1.jpg";